module.exports = __webpack_public_path__ + "static/img/S3.ac99f6e3.png";